// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 1700px) {
  .styles_text__vBDCA {
    font-size: 1.5rem; } }

@media (max-width: 1500px) {
  .styles_text__vBDCA {
    font-size: 1.25rem; } }

.styles_bold__uWZeu {
  font-weight: 600; }

.styles_break__nTUM3 {
  white-space: pre; }
`, "",{"version":3,"sources":["webpack://./src/modules/Core/styles/mixins.scss","webpack://./src/modules/Core/sub-modules/ui-kit/components/Text/styles.module.scss"],"names":[],"mappings":"AAEE;ECAF;IAEI,iBAAiB,EAAA,EAMpB;;ADRC;ECAF;IAMI,kBAAkB,EAAA,EAErB;;AAED;EACE,gBAAgB,EAAA;;AAGlB;EACE,gBAAgB,EAAA","sourcesContent":["// @import \"src/modules/Core/styles/mixins.scss\";\n@mixin respond-to($breakpoint) {\n  @media (max-width: $breakpoint) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 768px) {\n    @content;\n  }\n}\n\n@mixin multilineText($lines){\n  -webkit-line-clamp: $lines;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  display: -webkit-box;\n}","@import \"src/modules/Core/styles/mixins.scss\";\n\n.text {\n  @include respond-to(1700px) {\n    font-size: 1.5rem;\n  }\n\n  @include respond-to(1500px) {\n    font-size: 1.25rem;\n  }\n}\n\n.bold {\n  font-weight: 600;\n}\n\n.break {\n  white-space: pre;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"text": `styles_text__vBDCA`,
	"bold": `styles_bold__uWZeu`,
	"break": `styles_break__nTUM3`
};
export default ___CSS_LOADER_EXPORT___;
